<template>
    <div>
        <span>{{ value }}</span><br /><br />
        <div class="text-xs">
            <span v-if="source">
                <span class="text-bold text-gray-600">Source:</span> {{ source }}
            </span><br />
            <span v-if="medium">
                <span class="text-bold text-gray-600">Medium:</span> {{ medium }}
            </span><br />
            <span v-if="campaign">
                <span class="text-bold text-gray-600">Campaign:</span> {{ campaign }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ChannelAttribution',
        props: {
            account: {
                type: Object,
                required: true,
            },
        },
        computed: {
            value() {
                return this.account.channel_attribution
                    .split('_')
                    .map(e => e.substring(0, 1).toUpperCase() + e.substring(1))
                    .join(' ')
            },
            source() {
                return this.account.flags['utm.source'] ?? null
            },
            medium() {
                return this.account.flags['utm.medium'] ?? null
            },
            campaign() {
                return this.account.flags['utm.campaign'] ?? null
            }
        },
    }
</script>
